// extracted by mini-css-extract-plugin
export default {"header":"header_header__weC6P","logo":"header_logo__X+5Go"};